module.exports = __webpack_public_path__ + "static/media/TriAzurIcon.2ea7f79b.svg";